import React from "react";

import Layout from "../components/Layout";
import Testimonials from "../ui/mainPage/Testimonials";

const TestimonialsTemplate = (props) => {
    const { pageContext } = props;
    const { testimonials, isList } = pageContext;

    const testimonialsComponent = <Testimonials testimonials={testimonials} isList={isList} />;

    return <Layout children={testimonialsComponent} />;
}

export default TestimonialsTemplate;
